import React, { PureComponent } from 'react'
import {
  Section,
  Accordion,
  Checkbox,
  SliderCompound,
  Input,
  Image,
  SelectBox,
} from '../../components'

import { businessController, axios } from '../../apiService'
import { STRING } from '../../helpers'
import { ICONS } from '../../themes'
import { connect } from 'react-redux'
import { unClearSearchFilter } from '../../store/actions'

class SidebarFilterContaniner extends PureComponent {
  _isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      isReload: false,
      isCategoryOpen: false,
      businessCategory: [],
      businessType: [],
      regisCapitalDomain: [0, 1],
      regisCapitalValues: [0, 1],
      yearEstablishedOptions: [],
      yearEstablishedValue: null,
      financialScore: [
        { value: 1, label: 'Very Low' },
        { value: 2, label: 'Low' },
        { value: 3, label: 'Medium' },
        { value: 4, label: 'High' },
        { value: 5, label: 'Very High' },
        { value: -1, label: 'N/A' },
      ],
      sustainability: [
        { value: 1, label: 'Very Low' },
        { value: 2, label: 'Low' },
        { value: 3, label: 'Medium' },
        { value: 4, label: 'High' },
        { value: 5, label: 'Very High' },
        { value: -1, label: 'N/A' },
      ],
      operationalRisk: [
        { value: 1, label: 'Very Low' },
        { value: 2, label: 'Low' },
        { value: 3, label: 'Medium' },
        { value: 4, label: 'High' },
        { value: 5, label: 'Very High' },
      ],
      riskLevel: [
        { value: 1, label: 'Very Low' },
        { value: 2, label: 'Low' },
        { value: 3, label: 'Medium' },
        { value: 4, label: 'High' },
        { value: 5, label: 'Very High' },
      ],
      offlineAssessment: [
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' },
      ],
      onlineAssessment: [
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' },
      ],
      regulatoryRisk: [
        { value: 1, label: 'Code of Practice Accepted' },
        { value: 0, label: 'No information' },
      ],
      stepSlide: 500000,
      input: {
        isCheckedRegisCapital: false,
        isCheckedYearEstablished: false,
      },
    }
  }

  initState = state => {
    if (state) {
      if (this._isMounted) {
        return this.setState({
          input: state.searchFilter,
          financialScore: this._setDefaultFinancialScore(
            this.state.financialScore,
            state.searchFilter
          ),
          sustainability: this._setDefaultSustainabilityScore(
            this.state.sustainability,
            state.searchFilter
          ),
          operationalRisk: this._setDefaultOperationalRiskScore(
            this.state.operationalRisk,
            state.searchFilter
          ),
          riskLevelScore: this._setDefaultRiskLevelScore(
            this.state.riskLevel,
            state.searchFilter
          ),
          offlineAssessment: this._setDefaultOfflineAssessmentStatus(
            this.state.offlineAssessment,
            state.searchFilter
          ),
          onlineAssessment: this._setDefaultOnlineAssessmentStatus(
            this.state.onlineAssessment,
            state.searchFilter
          ),
          regulatoryRisk: this._setDefaultRegulatoryRisk(
            this.state.regulatoryRisk,
            state.searchFilter
          ),
        })
      }
    }
  }

  // componentWillReceiveProps(nextprops) {
  //   if (nextprops) {
  //     if (nextprops.searchFilter.isClear) {
  //       unClearSearchFilter(nextprops.searchFilter)
  //       this.initState(nextprops)
  //       this.fetchAll()
  //     }
  //   }
  // }

  componentDidMount() {
    this._isMounted = true
    this.initState(this.props)
    this.fetchAll()
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  fetchAll = async () => {
    try {
      const [
        businessCategory,
        businessType,
        regisCapitalValues,
        yearEstablishedOptions,
      ] = await Promise.all([
        this._fetchBusinessCategory(),
        this._fetchBusinessType(),
        this._fetchRegisCapital(),
        this._fetchYearList(),
      ])
      if (businessCategory) {
        if (this._isMounted) {
          this.setState({
            businessCategory: this._setDefaultBusinessCategory(
              businessCategory
            ),
          })
        }
      }
      if (businessType) {
        if (this._isMounted) {
          this.setState({
            businessType: this._setDefaultBusinessType(businessType),
          })
        }
      }
      if (regisCapitalValues) {
        if (
          !isNaN(regisCapitalValues.min) &&
          !isNaN(regisCapitalValues.max) &&
          regisCapitalValues.max !== regisCapitalValues.min
        ) {
          if (this._isMounted) {
            this.setState({
              regisCapitalDomain: [
                regisCapitalValues.min,
                regisCapitalValues.max,
              ],
              regisCapitalValues: this._setDefaultRegisCapital(
                regisCapitalValues
              ),
              stepSlide: regisCapitalValues.min,
            })
          }
        }
      }
      if (yearEstablishedOptions) {
        const yearEstablishedOptionsAftermap = yearEstablishedOptions.map(
          i => ({
            value: i.id,
            label: i.name,
          })
        )
        if (this._isMounted) {
          this.setState({
            yearEstablishedOptions: yearEstablishedOptionsAftermap,
            yearEstablishedValue: this._setDefaultYearList(
              yearEstablishedOptionsAftermap
            ),
          })
        }
      }
    } catch (error) {
      throw ('fetch sidebar filter fail', error)
    }
  }

  _fetchBusinessCategory() {
    return businessController().businessCategory()
  }

  _fetchBusinessType() {
    return businessController().businessType()
  }

  _fetchRegisCapital() {
    return businessController().regisCapital()
  }

  _fetchYearList() {
    return businessController().yearList()
  }

  _setDefaultBusinessCategory(data, props = this.props) {
    if (props.searchFilter.categories && props.searchFilter.categories.length) {
      props.searchFilter.categories.forEach(c => {
        const category = data.find(i => i.id === c.id)
        if (category) {
          category._checked = true
        }
        c.sub_categories.forEach(sc => {
          const sub_category = category.sub_categories.find(i => i.id === sc.id)
          if (sub_category) {
            sub_category._checked = true
          }
        })
      })
    }
    return data
  }

  _setDefaultBusinessType(data, props = this.props) {
    return data.map(i => {
      i._checked =
        props.searchFilter && props.searchFilter.businessType !== null
          ? props.searchFilter.businessType.some(d => {
              return d.id === i.id
            })
          : false
      return i
    })
  }

  _setDefaultRegisCapital(data, props = this.props) {
    return props.searchFilter.registeredCapital || [data.min, data.max]
  }

  _setDefaultYearList(data, props = this.props) {
    if (props.searchFilter.yearEstablished) {
      return (
        data.find(i => i.value === props.searchFilter.yearEstablished) ||
        data[0]
      )
    } else {
      return data[0]
    }
  }

  _setDefaultFinancialScore(data, props = this.props) {
    return data.map(i => {
      i._checked =
        props.financialScore && props.financialScore.indexOf(i.value) != -1
      return i
    })
  }

  _setDefaultSustainabilityScore(data, props = this.props) {
    return data.map(i => {
      i._checked =
        props.sustainabilityScore &&
        props.sustainabilityScore.indexOf(i.value) != -1
      return i
    })
  }

  _setDefaultOperationalRiskScore(data, props = this.props) {
    return data.map(i => {
      i._checked =
        props.operationRiskScore &&
        props.operationRiskScore.indexOf(i.value) != -1
      return i
    })
  }

  _setDefaultRiskLevelScore(data, props = this.props) {
    return data.map(i => {
      i._checked =
        props.riskLevelScore && props.riskLevelScore.indexOf(i.value) != -1
      return i
    })
  }

  _setDefaultOfflineAssessmentStatus(data, props = this.props) {
    return data.map(i => {
      i._checked =
        props.offlineAssessment &&
        props.offlineAssessment.indexOf(i.value) != -1
      return i
    })
  }

  _setDefaultOnlineAssessmentStatus(data, props = this.props) {
    return data.map(i => {
      i._checked =
        props.onlineAssessment && props.onlineAssessment.indexOf(i.value) != -1
      return i
    })
  }
  _setDefaultRegulatoryRisk(data, props = this.props) {
    return data.map(i => {
      i._checked =
        props.regulatoryRisk && props.regulatoryRisk.indexOf(i.value) != -1
      return i
    })
  }

  _onChangeCategory(item, parent) {
    const categories = []
    const businessCategory = JSON.parse(
      JSON.stringify(this.state.businessCategory)
    )
    // find root category
    const index = businessCategory.findIndex(
      i => i.id == (parent ? parent.id : item.id)
    )
    // set root category
    if (item.sub_categories) {
      const hasUnChecked = businessCategory[index].sub_categories.some(
        i => !i._checked
      )
      businessCategory[index]._checked =
        hasUnChecked || !businessCategory[index]._checked
    }
    // set sub categories
    businessCategory[index].sub_categories = businessCategory[
      index
    ].sub_categories.map(i => {
      i._checked = item.sub_categories
        ? businessCategory[index]._checked
        : item.id == i.id
        ? !i._checked
        : i._checked
      return i
    })
    // set root category
    if (parent) {
      businessCategory[index]._checked = businessCategory[
        index
      ].sub_categories.some(i => i._checked)
    }
    // set input categories
    businessCategory.forEach(i => {
      if (i._checked) {
        const category = Object.assign({}, i)
        category.sub_categories = JSON.parse(
          JSON.stringify(category.sub_categories.filter(si => si._checked))
        )
        category.sub_categories.forEach(i => {
          delete i._checked
        })
        delete category._checked
        categories.push(category)
      }
    })
    if (this._isMounted) {
      this.setState(
        {
          businessCategory,
          input: {
            ...this.state.input,
            categories,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeBusinessType(item) {
    const index = this.state.businessType.findIndex(i => i.id === item.id)
    const businessType = JSON.parse(JSON.stringify(this.state.businessType))
    businessType[index]._checked = !businessType[index]._checked

    const inputBusinessType = JSON.parse(JSON.stringify(businessType)).filter(
      i => i._checked
    )
    inputBusinessType.forEach(i => delete i._checked)
    if (this._isMounted) {
      this.setState(
        {
          businessType,
          input: {
            ...this.state.input,
            businessType: inputBusinessType.length ? inputBusinessType : null,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeIsCheckedRegisCapital() {
    if (this._isMounted) {
      this.setState(
        {
          input: {
            ...this.state.input,
            isCheckedRegisCapital: !this.state.input.isCheckedRegisCapital,
            registeredCapital: this.state.regisCapitalValues,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeRegisCapital(values) {
    if (this._isMounted) {
      this.setState(
        {
          regisCapitalValues: values,
          input: {
            ...this.state.input,
            isCheckedRegisCapital: true,
            registeredCapital: values,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeIsCheckedYearEstablished() {
    if (this._isMounted) {
      return this.setState(
        {
          input: {
            ...this.state.input,
            isCheckedYearEstablished: !this.state.input
              .isCheckedYearEstablished,
            yearEstablished: this.state.yearEstablishedValue.value,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeYearEstablished(selected) {
    if (this._isMounted) {
      this.setState(
        {
          yearEstablishedValue: selected,
          input: {
            ...this.state.input,
            isCheckedYearEstablished: true,
            yearEstablished: selected.value,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeFinancialScore(checked) {
    const financialScoreInput = []
    const financialScore = this.state.financialScore.map(i => {
      i._checked = checked.value === i.value ? !i._checked : i._checked
      if (i._checked) {
        financialScoreInput.push(i.value)
      }
      return i
    })
    if (this._isMounted) {
      this.setState(
        {
          financialScore,
          input: {
            ...this.state.input,
            financialScore: financialScoreInput.length
              ? financialScoreInput
              : null,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeSustainabilityScore(checked) {
    const sustainabilityScoreInput = []
    const sustainabilityScore = this.state.sustainability.map(i => {
      i._checked = checked.value === i.value ? !i._checked : i._checked
      if (i._checked) {
        sustainabilityScoreInput.push(i.value)
      }
      return i
    })
    if (this._isMounted) {
      this.setState(
        {
          sustainabilityScore,
          input: {
            ...this.state.input,
            sustainabilityScore: sustainabilityScoreInput.length
              ? sustainabilityScoreInput
              : null,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeOperationRiskScore(checked) {
    const operationRiskScoreInput = []
    const operationRiskScore = this.state.operationalRisk.map(i => {
      i._checked = checked.value === i.value ? !i._checked : i._checked
      if (i._checked) {
        operationRiskScoreInput.push(i.value)
      }
      return i
    })
    if (this._isMounted) {
      this.setState(
        {
          operationRiskScore,
          input: {
            ...this.state.input,
            operationRiskScore: operationRiskScoreInput.length
              ? operationRiskScoreInput
              : null,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeRiskLevelScore(checked) {
    const riskLevelScoreInput = []
    const riskLevelScore = this.state.riskLevel.map(i => {
      i._checked = checked.value === i.value ? !i._checked : i._checked
      if (i._checked) {
        riskLevelScoreInput.push(i.value)
      }
      return i
    })
    if (this._isMounted) {
      this.setState(
        {
          riskLevelScore,
          input: {
            ...this.state.input,
            riskLevelScore: riskLevelScoreInput.length
              ? riskLevelScoreInput
              : null,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeOfflineAssessmentStatus(checked) {
    const offlineAssessmentInput = []
    const offlineAssessmentStatus = this.state.offlineAssessment.map(i => {
      // i._checked = checked.value === i.value ? !i._checked : i._checked
      // if (i._checked) {
      //   offlineAssessmentInput.push(i.value)
      // }
      if (checked.value === i.value) {
        if (!checked._checked) {
          offlineAssessmentInput.push(checked.value)
        }
        i._checked = !i._checked
      } else {
        i._checked = false
      }
      return i
    })
    if (this._isMounted) {
      this.setState(
        {
          offlineAssessmentStatus,
          input: {
            ...this.state.input,
            offlineAssessment: offlineAssessmentInput.length
              ? offlineAssessmentInput
              : null,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeOnlineAssessmentStatus(checked) {
    const onlineAssessmentInput = []
    const onlineAssessmentStatus = this.state.onlineAssessment.map(i => {
      // i._checked = checked.value === i.value ? !i._checked : i._checked
      // if (i._checked) {
      //   offlineAssessmentInput.push(i.value)
      // }
      if (checked.value === i.value) {
        if (!checked._checked) {
          onlineAssessmentInput.push(checked.value)
        }
        i._checked = !i._checked
      } else {
        i._checked = false
      }
      return i
    })
    if (this._isMounted) {
      this.setState(
        {
          onlineAssessmentStatus,
          input: {
            ...this.state.input,
            onlineAssessment: onlineAssessmentInput.length
              ? onlineAssessmentInput
              : null,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _onChangeRegulatoryRisk(checked) {
    const regulatoryRiskInput = []
    const regulatoryRiskStatus = this.state.regulatoryRisk.map(i => {
      // i._checked = checked.value === i.value ? !i._checked : i._checked
      // if (i._checked) {
      //   regulatoryRiskInput.push(i.value)
      // }
      if (checked.value === i.value) {
        if (!checked._checked) {
          regulatoryRiskInput.push(checked.value)
        }
        i._checked = !i._checked
      } else {
        i._checked = false
      }
      return i
    })
    regulatoryRiskInput.push(checked.value)
    if (this._isMounted) {
      this.setState(
        {
          regulatoryRiskStatus,
          input: {
            ...this.state.input,
            regulatoryRisk: regulatoryRiskInput.length
              ? regulatoryRiskInput
              : null,
          },
        },
        this._triggerPropOnChange
      )
    }
  }

  _triggerPropOnChange() {
    if (this.props.onChange) {
      this.props.onChange(this.state.input)
      // this.fetchAll()
    }
  }

  get _categorySelectedCount() {
    let count = 0
    if (this.state.input) {
      if (this.state.input.categories) {
        this.state.input.categories.forEach(i => {
          count += i.sub_categories.length
        })
      }
    }
    return Number(count).toLocaleString()
  }

  _renderRiskList = statusRisk => {
    switch (statusRisk) {
      case 1:
        return <span className="status-risk green"></span>
      case 2:
        return <span className="status-risk green-light"></span>
      case 3:
        return <span className="status-risk yellow"></span>
      case 4:
        return <span className="status-risk orange"></span>
      case 5:
        return <span className="status-risk red"></span>

      default:
        break
    }
  }

  render() {
    return (
      <Section className="filter-sidebar-wrapper">
        <Section className="title">{STRING.FILTER}</Section>

        <Section className="filter is-float-inside category">
          <Accordion className="filter" isOpen={this.state.isCategoryOpen}>
            <Accordion.Head
              onClick={() => {
                if (this._isMounted) {
                  return this.setState({
                    isCategoryOpen: !this.state.isCategoryOpen,
                  })
                }
              }}
            >
              <Section className="filter-group-header">
                {STRING.SERVICE_CATEGORY} ({this._categorySelectedCount})
              </Section>
            </Accordion.Head>

            <Accordion.Body>
              {this.state.businessCategory.map(item => {
                return (
                  <Section className="checkbox-group" key={'cat' + item.id}>
                    <Checkbox
                      id={item.name}
                      checked={item._checked || false}
                      onChange={() => this._onChangeCategory(item)}
                    >
                      {item.name}
                    </Checkbox>
                    {item.sub_categories.map(i => (
                      <Section className="sub-group" key={'sub_cat' + i.id}>
                        <Checkbox
                          id={i.name}
                          checked={i._checked || false}
                          onChange={() => this._onChangeCategory(i, item)}
                        >
                          {i.name}
                        </Checkbox>
                      </Section>
                    ))}
                  </Section>
                )
              })}
            </Accordion.Body>
          </Accordion>
        </Section>

        <Section className="filter business-type">
          <Section className="filter-group-header">
            {STRING.BUSINESS_TYPE}
          </Section>

          <Section className="checkbox-group">
            {this.state.businessType.map(item => {
              return (
                <Checkbox
                  id={item.name}
                  key={item.id}
                  checked={item._checked || false}
                  onChange={() => this._onChangeBusinessType(item)}
                >
                  {item.name}
                </Checkbox>
              )
            })}
          </Section>
        </Section>

        {/* <Section className="filter registered-capital silder-compound">
          <Checkbox
            id="registered_capital"
            className="semibold-label"
            onChange={this._onChangeIsCheckedRegisCapital.bind(this)}
            checked={this.state.input.isCheckedRegisCapital}
          >
            {STRING.REGISTERED_CAPITAL} ({STRING.THB})
          </Checkbox>
        </Section> */}

        <Section className="filter registered-capital">
          <h4>
            {STRING.REGISTERED_CAPITAL} ({STRING.THB})
          </h4>
          <SliderCompound
            //className="sidebar-filter"
            isDisplayValue={true}
            valueUnit="THB"
            domain={this.state.regisCapitalDomain}
            values={this.state.regisCapitalValues}
            onChange={this._onChangeRegisCapital.bind(this)}
          />
        </Section>

        {/* <SliderCompound
          className="sidebar-filter"
          isDisplayValue={true}
          valueUnit="THB"
          disabled={!this.state.input.isCheckedRegisCapital}
          domain={this.state.regisCapitalDomain}
          values={this.state.regisCapitalValues}
          onChange={this._onChangeRegisCapital.bind(this)}
          step={this.state.stepSlide}
        /> */}

        {/* <Section className="filter year-estab silder-compound">
          <Checkbox
            id="year_established"
            className="semibold-label"
            onChange={this._onChangeIsCheckedYearEstablished.bind(this)}
            checked={this.state.input.isCheckedYearEstablished}
          >
            {STRING.YEAR_ESTABLISHED}
          </Checkbox>
        </Section> */}

        <Section className="filter established-filter">
          <Section className="filter-group-header">
            {STRING.YEAR_ESTABLISHED}
          </Section>
        </Section>

        <SelectBox
          id="year_established_filter"
          className="year-established-filter"
          value={this.state.yearEstablishedValue}
          options={this.state.yearEstablishedOptions}
          placeholder="Select"
          isSearchable={false}
          isClearable={false}
          //isDisabled={!this.state.input.isCheckedYearEstablished}
          onChange={this._onChangeYearEstablished.bind(this)}
          style={{ zIndex: '1' }}
        />

        <Section className="filter sustainability-score">
          <Section className="filter-group-header">{STRING.RISK_LEVEL}</Section>

          <Section className="checkbox-group">
            {this.state.riskLevel.map(i => (
              <Checkbox
                id={'riskLevel_score_' + i.value}
                key={i.value}
                checked={i._checked || false}
                onChange={() => this._onChangeRiskLevelScore(i)}
              >
                {this._renderRiskList(i.value)} {i.label}
              </Checkbox>
            ))}
          </Section>
        </Section>

        <Section className="filter financial-score">
          <Section className="filter-group-header">
            {STRING.FINANCIAL_RISK}
          </Section>
          <Section className="checkbox-group">
            {this.state.financialScore.map(i => (
              <Checkbox
                id={'financial_score_' + i.value}
                key={i.value}
                checked={i._checked || false}
                onChange={() => this._onChangeFinancialScore(i)}
              >
                {this._renderRiskList(i.value)} {i.label}
              </Checkbox>
            ))}
          </Section>
        </Section>

        <Section className="filter sustainability-score">
          <Section className="filter-group-header">{STRING.SS_RISK}</Section>

          <Section className="checkbox-group">
            {this.state.sustainability.map(i => (
              <Checkbox
                id={'sustainability_score_' + i.value}
                key={i.value}
                checked={i._checked || false}
                onChange={() => this._onChangeSustainabilityScore(i)}
              >
                {this._renderRiskList(i.value)} {i.label}
              </Checkbox>
            ))}
          </Section>
        </Section>

        <Section className="filter sustainability-score">
          <Section className="filter-group-header">
            {STRING.OFFLINE_COMPREHENSIVE_ASSESSMENT}
          </Section>

          <Section className="checkbox-group">
            {this.state.offlineAssessment.map(i => (
              <Checkbox
                type="checkbox"
                id={'offlineAssessment' + i.value}
                key={i.value}
                checked={i._checked || false}
                onChange={() => this._onChangeOfflineAssessmentStatus(i)}
                className="is-radio-type"
              >
                {i.label}
              </Checkbox>
            ))}
          </Section>
        </Section>

        <Section className="filter sustainability-score">
          <Section className="filter-group-header">
            {STRING.ONLINE_COMPREHENSIVE_ASSESSMENT}
          </Section>

          <Section className="checkbox-group">
            {this.state.onlineAssessment.map(i => (
              <Checkbox
                type="checkbox"
                id={'onlineAssessment' + i.value}
                key={i.value}
                checked={i._checked || false}
                onChange={() => this._onChangeOnlineAssessmentStatus(i)}
                className="is-radio-type"
              >
                {i.label}
              </Checkbox>
            ))}
          </Section>
        </Section>

        <Section className="filter">
          <Section className="filter-group-header">
            {STRING.REGULATORY_RISK}
          </Section>

          <Section className="checkbox-group">
            {this.state.regulatoryRisk.map(i => (
              <Checkbox
                type="checkbox"
                id={'regulatoryRisk' + i.value}
                key={i.value}
                checked={i._checked || false}
                onChange={() => this._onChangeRegulatoryRisk(i)}
                className="is-radio-type"
              >
                {i.label}
              </Checkbox>
            ))}
          </Section>
        </Section>
      </Section>
    )
  }
}
const mapStateToProps = state => {
  return {
    searchFilter: state.searchFilter,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    unClearSearchFilter: payload => dispatch(unClearSearchFilter(payload)),
  }
}

export const SidebarFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(SidebarFilterContaniner)
